export const ru = {
    action_submit: 'Отклонить',
    reject_for: 'Доступ для',
    title: 'Отклонить доступ',
};
